export default "__VITE_ASSET__DySl83N8__"